import { Link } from "react-router-dom";
import { boards } from "@/mocks/boards";
import { siteStats } from "@/mocks/site";

export default function TopicsSidebar({ activeBoard }: { activeBoard: string }) {
  return (
    <aside className="space-y-6">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="flex items-center gap-1.5 text-sm font-semibold text-foreground-950">
          <i className="ri-layout-grid-line text-primary-600" />
          板块导航
        </h3>
        <ul className="mt-3.5 space-y-1">
          <li>
            <Link
              to="/topics"
              className={`flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors ${
                activeBoard === ""
                  ? "bg-primary-50 font-medium text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              <span className="flex items-center gap-2">
                <i className="ri-apps-2-line" />
                全部话题
              </span>
              <span className="text-xs text-foreground-400">10</span>
            </Link>
          </li>
          {boards.map((board) => (
            <li key={board.id}>
              <Link
                to={`/topics?board=${board.id}`}
                className={`flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors ${
                  activeBoard === board.id
                    ? "bg-primary-50 font-medium text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                <span className="flex items-center gap-2">
                  <i className={board.icon} />
                  {board.name}
                </span>
                <span className="text-xs text-foreground-400">{board.todayPosts}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-100/60 p-5">
        <h3 className="flex items-center gap-1.5 text-sm font-semibold text-foreground-950">
          <i className="ri-pie-chart-2-line text-accent-500" />
          社区实时数据
        </h3>
        <dl className="mt-4 grid grid-cols-2 gap-3">
          {siteStats.map((stat) => (
            <div key={stat.label} className="rounded-md bg-background-50 p-3">
              <dt className="text-xs text-foreground-500">{stat.label}</dt>
              <dd className="mt-1 text-lg font-semibold text-foreground-950">{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-5">
        <h3 className="flex items-center gap-1.5 text-sm font-semibold text-secondary-900">
          <i className="ri-lightbulb-line" />
          发帖小贴士
        </h3>
        <ul className="mt-3 space-y-2.5 text-sm leading-relaxed text-foreground-700">
          <li className="flex gap-2">
            <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" />
            标题写清楚场景，更容易被推荐到热帖榜。
          </li>
          <li className="flex gap-2">
            <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" />
            先聊感受再谈观点，不同看法也能好好聊。
          </li>
          <li className="flex gap-2">
            <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" />
            一句话也能发帖，不用憋到完美再发。
          </li>
        </ul>
      </div>
    </aside>
  );
}